import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import { StorageService } from '../../../../Services/storage.service';
import {DataService} from '../../../../Services/data.service';
import { Title } from '@angular/platform-browser';
import { DateFilterService } from '../../../../Services/dateFilter.service';
import { AppConfigService } from '../../../../Services/app-config.service';
import { ResponseModel } from '../../../../DataModels/response-model';
import { NgbPaginationConfig } from '@ng-bootstrap/ng-bootstrap';
import { PagerStateService } from '../../../../Services/pager-state.service';
import { NgbpaginationConfigService } from '../../../../Services/ngbpagination-config.service';
import { HttpErrorResponse } from '@angular/common/http';
import {PermissionsService} from '../../../../Services/permissions.service';
import {ListPageBase} from '../../../list-page-base';

@Component({
  selector: 'app-transfer-list',
  templateUrl: './transfer-list.component.html',
  styleUrls: ['./transfer-list.component.css'],
  standalone: false
})
export class TransferListComponent extends ListPageBase implements OnInit {
  constructor(
    private localStorage: StorageService,
    private tableDataService: DataService,
    private dateFilter: DateFilterService,
    private titleService: Title,
    private ngbConfig: NgbPaginationConfig,
    private pagerConfig: NgbpaginationConfigService,
    private permissionsService: PermissionsService
  ) {
    super();
    this.ngbConfig = this.pagerConfig.getNgbPaginationConfig();
    this.vm.batchId = '';
    this.vm.batchesHidden = true;
    this.vm.transferFilter = { sort: null, text: null };
    this.vm.shipmentFilter = { sort: null };
    this.vm.batches = {};
  }

  get hasEditTransferPermission(): boolean {
    return this.permissionsService.Get('Admin') ||
      this.permissionsService.Get('EditTransfers');
  }

  vm: any = {
    list: {},
    title: 'Transfers',
    Preferences: [],
    permissions: [],
    formRoute: '/inventory/transfer/form',
  };
  transferCount = 0;
  isLoaded = false;



  ngOnInit() {
    this.restorePagerState();
    this.vm.list = [];
    this.init();
    this.titleService.setTitle(this.vm.title);
    this.search();
    this.getBatches(false);
  }

  // Set page title
  // (called in ngOnInit after permissions are checked, for consistency)

  init() {
    this.vm.permissions = JSON.parse(this.localStorage.StorageGet('Permissions'));
    if (!this.vm.permissions.EditTransfers && !this.vm.permissions.ViewTransfers && !this.vm.permissions.Admin) {
      document.location.href = '/';
    }
  }

  signature(signature) {
    this.vm.linkedSignature = signature;
    this.vm.getSignature = true;
    document.getElementById('closeSignatureModel').click();
    // this.save();
  }

  convertToNumbers() {
    for (const [x, value] of Object.entries(this.vm.list)) {
      this.vm.list[x].detail_total = Number(this.vm.list[x].detail_total);
      this.vm.list[x].payment_applied_total = Number(this.vm.list[x].payment_applied_total);
      this.vm.list[x].audit_sequence = Number(this.vm.list[x].audit_sequence);
    }
  }

  search(event?: any) {
    this.isLoaded = false;
    this.vm.undeliveredTransfers = event ? event : '';
    this.vm.searching = true;
    this.vm.batchId = '';
    this.vm.tempDescription = '';

    let paramString = '';
    paramString = '';
    paramString += 'search=' + (this.vm.transferSearch ? this.vm.transferSearch : '');
    paramString += '&fromDate=' + (this.vm.transferFromDate ? this.dateFilter.GetDateFormat(this.vm.transferFromDate) : '');
    paramString += '&toDate=' + (this.vm.transferToDate ? this.dateFilter.GetDateFormat(this.vm.transferToDate) : '');
    paramString += '&undeliveredTransfers=' + (this.vm.undeliveredTransfers ? this.vm.undeliveredTransfers : '');
    paramString += '&pageNumber=' + (this.page !== 0 ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;

    this.tableDataService.getApiListData('ListTransfers?' + paramString).subscribe({
      next: (result: ResponseModel) => {
        this.vm.list = result.Data;
        this.totalRecords = result.totalRecords;
        this.paginate(false);

        this.transferCount = result.totalRecords;
        this.vm.searching = false;
        this.isLoaded = true;
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
      },
      complete: () => {
      }
    });
  }

  filter(filter: any) {
    this.vm.transferFilter = Object.assign(this.vm.transferFilter, filter);
  }

  getBatchItems(batchId) {
    this.vm.tempDescription = '';
    this.vm.batchId = batchId;
    this.vm.searching = true;
    const obj: any = this.FilterObject(this.vm.batches, { id: this.vm.batchId }, true);
    if (obj.length == 0) {
      obj[0] = { description: '', locked: '' };
    }
    this.vm.tempDescription = (obj) ? obj[0].description : '';
    this.vm.tempBatchLocked = (obj) ? obj[0].locked : false;
    let paramString = '';
    paramString += 'batchId=' + ((this.vm.batchId) ? this.vm.batchId : '');
    paramString += '&batchType=' + 15;
    paramString += '&pageNumber=' + ((this.page !== 0) ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;

    this.tableDataService.getApiListData('entry', '?' + paramString).subscribe((result: ResponseModel) => {
      this.vm.list = result.Data;
      this.transferCount = result.totalRecords;
      this.convertToNumbers();
      this.vm.searching = false;
    });
  }

  getBatches(undelivered: boolean) {
    this.vm.searching = true;
    const tempBatchType = '15';

    let paramString = '';
    paramString += 'batchType=' + (tempBatchType ? tempBatchType : '');
    paramString += '&search=' + (this.vm.transferSearch ? this.vm.transferSearch : '');
    paramString += '&fromDate=' + (this.vm.transferFromDate ? this.dateFilter.GetDateFormat(this.vm.transferFromDate) : '');
    paramString += '&toDate=' + (this.vm.transferToDate ? this.dateFilter.GetDateFormat(this.vm.transferToDate) : '');
    paramString += '&lockedBatches=' + (this.vm.lockedBatches ? this.vm.lockedBatches : '');
    // paramString += '&transferNumberOfResults=' + (this.vm.transferNumberOfResults ? this.vm.transferNumberOfResults : '');
    paramString += '&includePosted=' + (this.vm.includePosted ? this.vm.includePosted : '');
    paramString += undelivered ? '&undeliveredTransfers=true' : '';

    this.tableDataService.getData('t_batch?' + paramString).subscribe((result: any[]) => {
      this.vm.batches = result;
      if (this.FilterObject(this.vm.batches, { id: this.vm.batchId }, true).length == 1) {
        this.vm.tempDescription = this.FilterObject(this.vm.batches, { id: this.vm.batchId }, true)[0].description;
        this.vm.tempBatchLocked = this.FilterObject(this.vm.batches, { id: this.vm.batchId }, true)[0].locked;
      }
      this.vm.searching = false;
    });
  }

  updateBatchesSelectedInModal(batchId: string) {
    this.getBatchItems(batchId);
    // this.paginate(false);
  }

  completeTransfer(id) {
    if (this.vm.permissions.Admin || this.vm.permissions.EditTransfers) {
      this.vm.buttonsDisabled = true;
      const changes = { completed: 'true' };
      this.tableDataService.patch('t_header', id, changes).then(
        (item: any) => {
          if (item) {
            // stuff
          }
          this.getPagedApiData();
          this.vm.buttonsDisabled = false;
        },
        (error: any) => {
          this.vm.buttonsDisabled = false;
          console.log(error);
        }
      );
    }
  }

  FilterObject(value: any[], filterObj: any, except = false) {
    if (!Array.isArray(value) || !filterObj) {
      return [];
    }
    const keys = Object.keys(filterObj);
    return value.filter(item => keys.every(k => item && item[k] === filterObj[k]));
  }

  onNavigate(aID: string) {
    this.router.navigateByUrl(this.vm.formRoute + '?transferId=' + aID).then();
  }

  hideBatches() {
    this.vm.batchesHidden = !this.vm.batchesHidden;
    this.vm.Preferences.ShowBatches = !this.vm.batchesHidden;
  }

  // ----------------- Server side paging --------------------

  protected fetchPage(): void {
    this.getPagedApiData();
  }

  getPagedApiData() {
    this.isLoaded = false;
    this.vm.searching = true;
    this.vm.batchId = '';
    this.vm.tempDescription = '';
    const tempBatchType = '15';

    let paramString = '';
    paramString += 'batchType=' + (tempBatchType ? tempBatchType : '');
    paramString += '&search=' + (this.vm.transferSearch ? this.vm.transferSearch : '');
    paramString += '&fromDate=' + (this.vm.transferFromDate ? this.dateFilter.GetDateFormat(this.vm.transferFromDate) : '');
    paramString += '&toDate=' + (this.vm.transferToDate ? this.dateFilter.GetDateFormat(this.vm.transferToDate) : '');
    paramString += '&undeliveredTransfers=' + (this.vm.undeliveredTransfers ? this.vm.undeliveredTransfers : '');
    paramString += '&transferNumberOfResults=' + (this.vm.transferNumberOfResults ? this.vm.transferNumberOfResults : '');
    paramString += '&pageNumber=' + (this.page !== 0 ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;
    this.tableDataService.getApiListData('ListTransfers?' + paramString).subscribe({
      next: (result: ResponseModel) => {
        this.vm.list = result.Data;
        this.totalRecords = result.totalRecords;
        this.paginate(false);

        this.transferCount = result.totalRecords;
        this.vm.searching = false;
        this.isLoaded = true;
      },
      error: (error: any) => {
        console.log(error.statusText);
      }
    });
  }

  serverSearch(value: any) {
    this.vm.transferSearch = value.searchTerm;
    this.vm.transferFromDate = value.fromDate;
    this.vm.transferToDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  clearServerSearch(value: any) {
    this.vm.transferSearch = value.searchTerm;
    this.vm.transferFromDate = value.fromDate;
    this.vm.transferToDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  hideSearch() {
    this.vm.searchHidden = !this.vm.searchHidden;
  }

}
